import { Grid, GridParams } from "../grid";

export function initialiseDyGridWithAngular(angular: any) {
  const angularModule = angular.module("DyGrid", []);
  angularModule.directive("DyGrid", function () {
    return {
      restrict: "A",
      controller: ['$element', '$scope', '$compile', '$attrs', AngularDirectiveController],
      scope: true
    };
  });
}

function AngularDirectiveController($element: any, $scope: any, $compile: any, $attrs: any) {
  let gridOptions: any;
  let quickFilterOnScope: any;

  const keyOfGridInScope = $attrs.DyGrid;
  quickFilterOnScope = keyOfGridInScope + '.quickFilterText';
  gridOptions = $scope.$eval(keyOfGridInScope);
  if (!gridOptions) {
    console.warn("WARNING - grid options for DYNA Grid not found. Please ensure the attribute dyna-grid points to a valid object on the scope");
    return;
  }

  const eGridDiv = $element[0];
  const gridParams: GridParams = {
    $scope: $scope,
    $compile: $compile,
    quickFilterOnScope: quickFilterOnScope
  };
  let grid: Grid | null = new Grid(eGridDiv, gridOptions, gridParams);

  $scope.$on("$destroy", function () {
    if (grid) {
      grid.destroy();
    }
    grid = null;
  });
}
